import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { LanguageProvider } from './LanguageContext';
import reportWebVitals from './reportWebVitals';

import faviconPng from './media/images/nadyhololLogo-removebg-preview.png';

// Replace CRA's default `favicon.ico` with the project's logo PNG.
const faviconLink = document.querySelector("link[rel='icon']") || document.createElement('link');
faviconLink.setAttribute('rel', 'icon');
faviconLink.setAttribute('type', 'image/png');
faviconLink.setAttribute('href', faviconPng);
if (!faviconLink.parentNode) {
  document.head.appendChild(faviconLink);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
